//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from './../../components/helpers.js'
import { formatEmployeeName } from './OrderAdmittanceFunctions.js'

import TableEmployees from './../Employee/TableEmployees.vue'
import Table from './../../components/Table/Table.vue'
import DateTimeField from './../../components/Field/DateTimeField.vue'

export default {
  components: {
    TableEmployees,
    Table,
    DateTimeField
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      formatEmployeeName: formatEmployeeName,
      selectedEmployee: null,
      modalOpened: false,
      columns: [
        {
          name: 'time',
          label: 'Дата/время',
          align: 'left',
          field: 'time',
          sortable: false,
          format: formatTime
        },
        {
          name: 'fio',
          label: 'Cотрудник',
          align: 'left',
          field: 'fio',
          sortable: false
        },
        {
          name: 'position',
          label: 'Должность сотрудника',
          align: 'left',
          field: 'position',
          sortable: false
        },
        {
          name: 'limit',
          label: 'Срок',
          align: 'left',
          field: 'limit',
          sortable: false,
          format: formatTime
        }
      ]
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state !== 'AD3' && this.orderAdmittance.state !== 'AD4'
    }
  },
  methods: {
    onShowProlongingEmployeesTable: function () {
      if (this.readonly) {
        return
      }
      this.employeeTable = 'prolongingEmployeesTable'
      this.selectedEmployee = this.orderAdmittance.prolongingEmployee
      this.modalOpened = true
    },
    saveProlongingEmployee: function (employee) {
      this.orderAdmittance.prolongingEmployee.fio = employee.shortName
      this.orderAdmittance.prolongingEmployee.key = employee.key
      this.orderAdmittance.prolongingEmployee.position = employee.positionName
      this.closeModal()
    },
    closeModal: function () {
      this.modalOpened = false
      this.selectedEmployee = null
    }
  }
}

